const state = {
	activeDrawer: null,
	drawerType: null, // 'edit', 'add', etc.
	drawerData: null, // Additional data for the drawer
	drawerPosition: 'right', // Default position
	drawerLocked: false, // When true, drawer is part of page layout instead of overlay
	drawerMinimized: false, // When true, drawer is collapsed to minimal width
	drawerWidth: 580 // Current drawer width in pixels
}

const mutations = {
	SET_ACTIVE_DRAWER(state, { euid, type, data }) {
		state.activeDrawer = euid
		state.drawerType = type
		state.drawerData = data
	},
	CLOSE_DRAWER(state) {
		state.activeDrawer = null
		state.drawerType = null
		state.drawerData = null
	},
	SET_DRAWER_POSITION(state, position) {
		state.drawerPosition = position
	},
	SET_DRAWER_LOCKED(state, locked) {
		state.drawerLocked = locked
	},
	SET_DRAWER_MINIMIZED(state, minimized) {
		state.drawerMinimized = minimized
	},
	SET_DRAWER_WIDTH(state, width) {
		state.drawerWidth = width
	}
}

const actions = {
	openDrawer({ commit }, { euid, type, data }) {
		// Always close any existing drawer first
		commit('CLOSE_DRAWER')
		// Then open the new drawer
		commit('SET_ACTIVE_DRAWER', { euid, type, data })
	},
	closeDrawer({ commit }) {
		commit('CLOSE_DRAWER')
	},
	setDrawerPosition({ commit }, position) {
		commit('SET_DRAWER_POSITION', position)
	},
	setDrawerLocked({ commit }, locked) {
		commit('SET_DRAWER_LOCKED', locked)
	},
	toggleDrawerLocked({ commit, state }) {
		commit('SET_DRAWER_LOCKED', !state.drawerLocked)
	},
	setDrawerMinimized({ commit }, minimized) {
		commit('SET_DRAWER_MINIMIZED', minimized)
	},
	setDrawerWidth({ commit }, width) {
		commit('SET_DRAWER_WIDTH', width)
	}
}

const getters = {
	isDrawerOpen: (state) => state.activeDrawer !== null,
	activeDrawerEuid: (state) => state.activeDrawer,
	drawerType: (state) => state.drawerType,
	drawerData: (state) => state.drawerData,
	drawerPosition: (state) => state.drawerPosition,
	drawerLocked: (state) => state.drawerLocked,
	drawerMinimized: (state) => state.drawerMinimized,
	drawerWidth: (state) => state.drawerWidth
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
